import type { TowerDesign } from "@/game/towerSpec";
/** EXACT: three-legged ROHN 180ft tapered self-support lattice; 101/110 mph. Per-section face-width taper in drawing table (not text-extractable) -> base ~14ft/top ~4ft estimated. */
export const design: TowerDesign = {
  id: "selfsupport-butternut-180ft",
  name: "Self-Support (Butternut 180 ft, ROHN)",
  description: "Real 180 ft three-legged ROHN tapered self-support lattice, CT (101 mph).",
  author: "reference: 02_engineering_drawings",
  spec: {
    type: "lattice",
    height: 54.86,
    stack: { faces: 3, panels: 16, baseRadius: 2.46, topRadius: 0.70,
      legSection: "legXL", braceSection: "braceHeavy", legMaterial: "a572", braceMaterial: "a36", bracing: "X" },
    foundation: { soil: "dense-sand", base: { type: "pad", width: 2.5, diameter: 1, depth: 2.5, concrete: "c30" },
      connection: { kind: "anchorBolts", nBolts: 8, bolt: "b1_5", grade: "f1554_55", boltCircleDia: 0.7, embedment: 0.8, edgeDistance: 0.35, platePlanArea: 0.5, plateThickness: 0.045, plateGrade: "a36rod", fc: 30e6 } },
  },
};
